import { useEffect, useState } from "react";
import { useDiseasesSections } from "./useDiseasesSections";
import { DDSortType } from "fe-common/hooks/sortFeaturesWithCrs";

export function useForceDDOnceInWizard(force = true) {
  const [runDD, setRunDD] = useState<boolean>(force);
  useEffect(() => {
    setRunDD(force);
  }, [force]);

  useEffect(() => {
    if (runDD) setRunDD(false);
  }, [runDD]);

  useDiseasesSections(
    DDSortType.BySuspicionIndex,
    runDD,
    false /*No need for citations in the wizard*/,
  );
}
